import React, { useState } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const CommonAccordion = ({ Icon = <></>, title = "", children = <></> }) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (title) => {
        setExpanded(title);
    };


    return (<div className='my-2'>
        <Accordion expanded={expanded === title} onChange={() => handleChange(title)}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography as="div" sx={{ width: '33%', flexShrink: 0, display: "flex" }}>
                    <div>{Icon}</div>
                    <div className='ml-3'>{title}</div>
                </Typography>
            </AccordionSummary>
            <div className='px-3 mb-3'>
                {children}
            </div>
        </Accordion>
    </div>)


    return (
        <div className='my-2'>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography as="div" sx={{ width: '33%', flexShrink: 0, display: "flex" }}>
                        <div>
                            {Icon}
                            {/* <Icon /> */}
                        </div>
                        <div className='ml-3'>{title}</div>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className='d-flex justify-content-between align-items-center'>
                            {children}
                        </div>
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}